// Referral Reward credit: spendable only on clinic invoices (not HD/QC) where checkout left it on.
export const isRewardEligibleInvoice = (invoice: any) =>
  invoice?.billing_type === "clinic" && !invoice?.sub_order_id && invoice?.use_reward_credit !== false;

// How much Reward credit these invoices can take, capped by the balance.
export const usableRewardCredit = (balance: unknown, invoices: any[] = [], amountKey = "due_amount") => {
  const eligibleDue = invoices
    .filter(isRewardEligibleInvoice)
    .reduce((sum, invoice) => sum + (parseFloat(invoice?.[amountKey]) || 0), 0);
  return Number(Math.min(Number(balance) || 0, eligibleDue).toFixed(2));
};
